<template>
  <li class="menu-builder__item-wrap" :data-id="content.id">
    <div v-if="isReady" class="menu-builder__item">
      <div class="menu-builder__item-inner">
        <div class="menu-builder__item-title">
          <span>{{ entity.name }}</span>
        </div>
        <div class="menu-builder__item-btns">
          <button class="btn btn-primary btn-add">Add item</button>
          <button class="btn btn-primary btn-edit">Edit</button>
          <button class="btn btn-danger btn-delete">Delete</button>
        </div>
      </div>
    </div>
    <ul v-if="entity.children && entity.children.length">
      <term-item
        v-for="item in content.children"
        :key="item.id"
        :content="item"
      />
    </ul>
  </li>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TermItem',

  props: {
    content: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isReady: false,
      entity: {},
    };
  },

  mounted() {
    this.entity.id = this.content.id;
    this.entity.name = this.content.name;
    this.entity.parent_id = this.content.parent_id;
    this.entity.weight = this.content.weight;
    this.entity.children = _.sortBy(this.content.children, item => item.weight);
    this.isReady = true;
  },
};
</script>



// WEBPACK FOOTER //
// TermsOrderItem.vue?05c83a76